const tabWebRealisations = [
  {
    id: 1,
    titre: "Refonte site Association",
    annee: "2026",
    src: "/site-spadtribu-association-vtt.webp",
    alt: "spadtribu-vtt",
    link: "https://www.spadtribu.fr/",
    git: "",
    description:
      "Refonte complète d'une plateforme Joomla vers une architecture moderne Headless (Next.js + Cosmic CMS).",
    objectif:
      "Améliorer le référencement et les performances du site, tout en offrant une expérience utilisateur optimale.",
    technique:
      "Intégration d'un CMS Headless et consommation d'API pour la gestion dynamique du calendrier sportif et des pages du site.",
    techno: "Next.js",
    technos: "Next.js, Cosmic CMS, API, SEO, Performance",
    type: "web",
    accueil: true,
  },
  {
    id: 2,
    titre: "Refonte Portfolio",
    annee: "2026",
    src: "/site-portfolio-nextjs.jpg",
    alt: "Portfolio Next.js",
    link: "https://fialons-web.fr/",
    git: "",
    description:
      "Refonte complète de mon portfolio avec migration vers une architecture moderne sous Next.js.",
    objectif:
      "Maximiser les performances web, optimiser le référencement naturel (SEO) et garantir une qualité de code irréprochable.",
    technique:
      "Intégration d'un CMS Headless et validation de la qualité logicielle certifiée par une note A sur SonarQube.",
    techno: "Next.js",
    technos: "Next.js, Tailwind CSS, SonarQube, Jest, Cosmic CMS, SEO",
    type: "web",
    accueil: false,
  },
  {
    id: 3,
    titre: "Déploiement NocoDB",
    annee: "2025",
    src: "/site-nocodb-grafana.png",
    alt: "NocoDB Grafana",
    link: "",
    git: "https://gitlab.com/sf-web/monitoring-ansible",
    description:
      "Déploiement automatisé de NocoDB sur AWS via Terraform et Ansible, avec monitoring CloudWatch et visualisation des métriques dans Grafana.",
    objectif:
      "Industrialiser l'infrastructure cloud pour garantir un déploiement reproductible, sécurisé et entièrement sous contrôle via des métriques en temps réel.",
    technique:
      "Provisionnement de l'infrastructure AWS avec Terraform (IaC), configuration automatisée par Ansible, et mise en place d'une stack de supervison connectant CloudWatch à Grafana.",
    techno: "Terraform",
    technos: "AWS, Terraform, Ansible, NocoDB, Grafana, CloudWatch",
    type: "devops",
    accueil: false,
  },
  {
    id: 4,
    titre: "Gestion de Bibliothèque & Volume de Données",
    annee: "2025",
    src: "/site-bibliotheque.webp",
    alt: "Bibliotheque",
    link: "",
    git: "https://github.com/SandrineFial/symfony_bibliotheque_public",
    description:
      "Application Symfony gérant un catalogue de plus de 3 000 ouvrages avec authentification, recherche avancée, enrichissement de données via API et pipeline CI/CD.",
    objectif:
      "Concevoir une application robuste capable de traiter un volume conséquent de données tout en garantissant des performances de recherche fluides et une haute qualité de code.",
    technique:
      "Développement du CRUD sur MySQL, intégration de l'API OpenLibrary (enrichissement ISBN), génération d'exports PDF et automatisation des tests/qualité (SonarQube) via GitHub Actions.",
    techno: "Symfony",
    technos:
      "Symfony, MySQL, Bootstrap, Twig, SonarQube, GitHub Actions, CI/CD",
    type: "web",
    accueil: true,
  },
  {
    id: 5,
    titre: "Site Vitrine & Backend Emailing",
    annee: "2024",
    src: "/site-electricitearmanini.webp",
    alt: "React Electricite",
    link: "https://www.electricitearmanini.fr/",
    git: "",
    description:
      "Conception et développement d'un site vitrine moderne pour un artisan électricien, combinant une interface dynamique et un service d'envoi d'emails sécurisé.",
    objectif:
      "Renforcer la visibilité locale de l'entreprise, optimiser le référencement naturel (SEO) et faciliter la prise de contact pour les prospects.",
    technique:
      "Développement du Frontend responsive sous React et Tailwind CSS, et création d'une API backend sous Node.js/Express dédiée au traitement sécurisé des formulaires de contact.",
    techno: "React",
    technos: "React, Tailwind CSS, Node.js, Express, SEO",
    type: "web",
    accueil: false,
  },
  {
    id: 6,
    titre: "Plateforme de Réservation & Paiement en Ligne",
    annee: "2023",
    src: "/site-animarc.webp",
    alt: "Animarc Vue.js",
    link: "https://www.animarc.fr/",
    git: "",
    description:
      "Développement complet d'une application de réservation et d'inscription en ligne sécurisée avec tunnel de paiement et gestion d'accès.",
    objectif:
      "Dématérialiser le processus d'inscription, garantir des transactions sécurisées et supporter une forte charge tout en offrant une expérience utilisateur fluide.",
    technique:
      "Conception d'une API Node.js/Express connectée à MongoDB avec mise en cache Redis et rate limiting. Intégration du paiement en ligne, authentification sécurisée, suivi des erreurs avec Sentry et validation qualité via SonarQube.",
    techno: "Vue.js & Node.js",
    technos:
      "Vue.js, Tailwind CSS, DaisyUI, Node.js, Express, MongoDB, Redis, Sentry, SonarQube",
    type: "web",
    accueil: true,
  },
  {
    id: 7,
    titre: "Générateur de Briefs & Gestion CRUD",
    annee: "2023",
    src: "/site-briefscreativ.webp",
    alt: "BriefCreativ",
    link: "https://brief-creativ-frontend.vercel.app/",
    git: "",
    description:
      "Application MERN permettant de générer des briefs créatifs aléatoires grâce à des algorithmes personnalisés, avec un espace membre sécurisé pour la gestion de contenu.",
    objectif:
      "Stimuler la créativité des utilisateurs via un générateur dynamique tout en leur offrant un espace personnel complet pour sauvegarder, commenter et gérer leurs projets.",
    technique:
      "Développement d'algorithmes de génération aléatoire côté Frontend (React) et création d'une API REST (Node.js/Express) gérant l'authentification sécurisée, la persistance MongoDB et le CRUD des commentaires.",
    techno: "React & Node.js",
    technos: "React, Tailwind CSS, DaisyUI, Node.js, Express, MongoDB",
    type: "web",
    accueil: false,
  },
  {
    id: 8,
    titre: "Plateforme Tutoriels & Coaching Tir à l'Arc",
    annee: "2022",
    src: "/site-boxdelarcher-jaune.webp",
    alt: "Entrainement",
    link: "https://boxdelarcher.fr/",
    git: "",
    description:
      "Site d'entraînement spécialisé proposant des tutoriels thématiques et un affichage dynamique de données techniques via une API dédiée.",
    objectif:
      "Centraliser et structurer des contenus pédagogiques tout en offrant une expérience de lecture rapide et un affichage fluide des données d'entraînement.",
    technique:
      "Conception d'une interface React responsive avec Tailwind CSS/DaisyUI, rédaction des contenus techniques et consommations d'API Node.js/Express pour la récupération et la persistance des données sous MongoDB.",
    techno: "React & Node.js",
    technos: "React, Tailwind CSS, DaisyUI, Node.js, Express, MongoDB",
    type: "web",
    accueil: false,
  },
  {
    id: 9,
    titre: "Dashboard d'Administration & Data Viz",
    annee: "2021",
    src: "/site-entrainement.webp",
    alt: "Entrainement",
    link: "",
    git: "",
    description:
      "Interface de gestion interne sécurisée permettant la visualisation de données dynamiques et le pilotage d'activité via des tableaux de bord sur mesure.",
    objectif:
      "Offrir une interface d'administration centralisée, performante et intuitive pour faciliter la prise de décision grâce à une restitution graphique des données.",
    technique:
      "Développement d'un backend PHP connecté à PostgreSQL avec authentification sécurisée, gestion complète des droits/CRUD et intégration de graphiques dynamiques interactifs (jQuery/Chart.js).",
    techno: "PHP & PostgreSQL",
    technos: "PHP, jQuery, Bootstrap, PostgreSQL",
    type: "web",
    accueil: false,
  },
  {
    id: 10,
    titre: "Sites Agences Immobilières & SEO",
    annee: "2019",
    src: "/site-immo.webp",
    alt: "Symfony Immobilier",
    link: "https://www.agencemarchetti.com/fr/",
    git: "",
    description:
      "Intégration d'interfaces web et optimisation du référencement naturel pour un réseau de sites d'agences immobilières sous Symfony.",
    objectif:
      "Maximiser la visibilité des annonces immobilières sur les moteurs de recherche tout en offrant une navigation fluide et responsive aux acheteurs et locataires.",
    technique:
      "Intégration sur mesure des gabarits HTML/CSS via le moteur de template Twig sous Symfony, structuration des données sémantiques et optimisation technique du SEO (balisage, performances de chargement).",
    techno: "Symfony",
    technos: "Symfony, Twig, HTML, CSS, SEO",
    type: "web",
    accueil: false,
  },
  {
    id: 11,
    titre: "Billetterie Multilingue Grand Prix F1",
    annee: "2019",
    src: "/site-grand-prix.webp",
    alt: "Grand Prix de Monaco",
    link: "https://www.monacograndprixticket.com/",
    git: "",
    description:
      "Développement d'une plateforme e-commerce multilingue dédiée à la vente de billets pour le Grand Prix de Formule 1 de Monaco.",
    objectif:
      "Capter un trafic international haut de gamme et offrir un parcours d'achat sécurisé, rapide et accessible en plusieurs langues.",
    technique:
      "Développement en PHP/JavaScript du système de billetterie en ligne, gestion dynamique de l'internationalisation (i18n) et optimisation SEO poussée sur des mots-clés très concurrentiels.",
    techno: "PHP & JavaScript",
    technos: "PHP, JavaScript, Multilingue (i18n), E-commerce, SEO",
    type: "web",
    accueil: false,
  },
  {
    id: 12,
    titre: "Plateforme Club Sportif & Gestion d'Événements",
    annee: "2013",
    src: "/site-archers-menton.webp",
    alt: "Archers de St Michel",
    link: "",
    git: "",
    description:
      "Développement sur mesure d'un site d'association sportive avec espace membre sécurisé, gestion des inscriptions et événements, suivi d'une migration WordPress.",
    objectif:
      "Facilitation de la gestion administrative du club, dématérialisation des inscriptions aux compétitions et maintien d'un site facile à mettre à jour.",
    technique:
      "Conception initiale du backend PHP et de la base MySQL (authentification, CRUD événements), puis refonte sous WordPress pour autonomiser les responsables d'association.",
    techno: "PHP & WordPress",
    technos: "PHP, MySQL, WordPress, SEO",
    type: "web",
    accueil: false,
  },
];

export default tabWebRealisations;
